// frontend/admin-portal/src/components/users/RoleCard.jsx
import React from "react";
import { Card, Badge, Button, Can } from "@fiberhome/shared-ui";

export default function RoleCard({ role, onEdit, onDuplicate, onDelete }) {
  const isWildcard = (role.permissions || []).includes("*");
  const count = isWildcard ? "All" : (role.permissions || []).length;

  return (
    <Card hoverable>
      <div className="fh-role-card">
        <div className="fh-role-card__head">
          <div>
            <div className="fh-role-card__title">
              {role.displayName}
              {role.isSystem && <Badge variant="default">system</Badge>}
            </div>
            <div className="fh-role-card__slug">{role.name}</div>
          </div>
          <div className="fh-role-card__count">
            {count} <span className="text-muted">perms</span>
          </div>
        </div>

        {role.description && (
          <p className="fh-role-card__desc">{role.description}</p>
        )}

        <div className="fh-role-card__meta">
          <span>
            <strong>{role.userCount || 0}</strong> user
            {role.userCount === 1 ? "" : "s"}
          </span>
          {!role.isActive && <Badge variant="default">Inactive</Badge>}
          {isWildcard && <Badge variant="danger">wildcard</Badge>}
        </div>

        <div className="fh-role-card__actions">
          <Can permission="roles.write">
            <Button size="sm" variant="outline" onClick={() => onEdit(role)}>
              Edit
            </Button>
          </Can>
          <Can permission="roles.write">
            <Button size="sm" variant="ghost" onClick={() => onDuplicate(role)}>
              Duplicate
            </Button>
          </Can>
          {!role.isSystem && (
            <Can permission="roles.delete">
              <Button
                size="sm"
                variant="ghost"
                onClick={() => onDelete(role)}
                disabled={role.userCount > 0}
                title={role.userCount > 0 ? "Remove users first" : "Delete"}
              >
                Delete
              </Button>
            </Can>
          )}
        </div>
      </div>
    </Card>
  );
}
